function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from "react";

var AccordionSpot = /*#__PURE__*/function (_React$Component) {
  _inherits(AccordionSpot, _React$Component);

  var _super = _createSuper(AccordionSpot);

  function AccordionSpot(props) {
    var _this;

    _classCallCheck(this, AccordionSpot);

    _this = _super.call(this, props);
    _this.state = {};

    _this.props.settings.elements.forEach(function (element, index) {
      _this.state["displayText".concat(index)] = false;
    });

    _this.handleHeaderClick = _this.handleHeaderClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AccordionSpot, [{
    key: "handleHeaderClick",
    value: function handleHeaderClick(event, index) {
      event.preventDefault();
      var newState = {};
      newState["displayText".concat(index)] = !this.state["displayText".concat(index)];
      this.setState(newState);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var settings = this.props.settings;
      var accordionList = settings.elements || [];
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
        className: "image-spot-elements"
      }, accordionList.map(function (item, index) {
        return /*#__PURE__*/React.createElement("li", {
          className: "image-spot-element ".concat(_this2.state["displayText".concat(index)] ? "open" : ""),
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: "scLooseFrameZone",
          sc_item: item.sitecoreItem || ''
        }, /*#__PURE__*/React.createElement("span", {
          className: "scChromeData"
        }, item.sitecoreChromeData || ''), /*#__PURE__*/React.createElement("div", {
          className: "image-spot-element-header",
          onClick: function onClick(evt) {
            _this2.handleHeaderClick(evt, index);
          }
        }, /*#__PURE__*/React.createElement("p", {
          dangerouslySetInnerHTML: {
            __html: item.header
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: "image-spot-element-content"
        }, /*#__PURE__*/React.createElement("div", {
          className: "image-spot-element-text"
        }, /*#__PURE__*/React.createElement("p", {
          dangerouslySetInnerHTML: {
            __html: item.text
          }
        })))));
      })));
    }
  }]);

  return AccordionSpot;
}(React.Component);

export default AccordionSpot;